import { __awaiter } from "tslib";
import { useEffect, useState } from 'react';
import { default as ScriptLoaderUtil } from '../util/ScriptLoaderUtil';
import { andesSaferpayFieldStyles, SAFERPAY_SCRIPT_ID } from '../util/SaferpayUtil';
import { useAemConfig } from '@as-react/common-components';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
import { SaferpayFieldTypeEnum } from '@as-react/common-types';
export const useSaferpay = ({ paymentMethods, enabled = true, cvvPlaceholder }) => {
    const { t } = useTranslation(I18N_NAMESPACES.buy);
    const [isReady, setIsReady] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [validation, setValidation] = useState();
    const { saferpayConfig } = useAemConfig();
    const loadSaferpayScript = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield ScriptLoaderUtil.loadScript(saferpayConfig.fields.scriptUrl, SAFERPAY_SCRIPT_ID, true);
            setIsReady(true);
        }
        catch (_a) { }
    });
    useEffect(() => {
        enabled && !isReady && loadSaferpayScript();
    }, [enabled, isReady]);
    useEffect(() => {
        if (!isReady || !enabled) {
            return;
        }
        setValidation(undefined);
        try {
            window.SaferpayFields.init({
                accessToken: saferpayConfig.fields.accessToken,
                url: saferpayConfig.fields.apiUrl,
                paymentMethods,
                placeholders: {
                    cardnumber: t(`${I18N_NAMESPACES.buy}:buy.payment.saferpay.field.${SaferpayFieldTypeEnum.CARDNUMBER}.placeholder`),
                    holdername: t(`${I18N_NAMESPACES.buy}:buy.payment.saferpay.field.${SaferpayFieldTypeEnum.HOLDERNAME}.placeholder`),
                    expiration: t(`${I18N_NAMESPACES.buy}:buy.payment.saferpay.field.${SaferpayFieldTypeEnum.EXPIRATION}.placeholder`),
                    cvc: cvvPlaceholder
                        ? t(`${I18N_NAMESPACES.buy}:buy.payment.saferpay.field.${SaferpayFieldTypeEnum.CVC}.placeholder`)
                        : '',
                },
                style: andesSaferpayFieldStyles,
                onError: () => setHasError(true),
                onValidated: (e) => {
                    setHasError(false);
                    return setValidation(prev => (Object.assign(Object.assign({}, prev), { [e.fieldType]: e })));
                },
            });
        }
        catch (e) {
            setHasError(true);
        }
    }, [enabled, isReady]);
    return {
        hasError,
        validation,
    };
};
